import ReactJson from 'react-json-view'
import { useTranslation } from 'react-i18next'

import { Drawer } from '@percent/lemonade'
import { CopyProps, JsonViewToggleProps } from './JsonViewToggle.types'
import styles from './JsonViewToggle.module.scss'

const handleCopy = (copy: CopyProps) => {
  navigator.clipboard.writeText(JSON.stringify(copy.src, null, '\t'))
}

export function JsonViewToggle({ rawJsonData, isOpen, onClose, onOpen }: JsonViewToggleProps) {
  const { t } = useTranslation()

  return (
    <Drawer
      classNames={{ body: styles.drawerBody, header: styles.drawerHeader, title: styles.drawerTitle }}
      title={t('typography.title')}
      position="right"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
    >
      <hr className={styles.separator} />
      <ReactJson
        style={{
          paddingTop: '20px',
          wordBreak: 'break-all',
          fontSize: '14px'
        }}
        name={false}
        src={rawJsonData}
        theme="summerfruit"
        displayDataTypes={false}
        enableClipboard={handleCopy}
      />
    </Drawer>
  )
}
